import { render, staticRenderFns } from "./task_commentqrcode.vue?vue&type=template&id=2902afee&scoped=true"
import script from "./task_commentqrcode.vue?vue&type=script&lang=js"
export * from "./task_commentqrcode.vue?vue&type=script&lang=js"
import style0 from "./task_commentqrcode.vue?vue&type=style&index=0&id=2902afee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2902afee",
  null
  
)

export default component.exports